import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import AuthLayout from "@/components/layout/AuthLayout";
import { FormAlert } from "@/components/common/Alert";
import { api, errorMessage } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data.message);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Forgotten your password"
      subtitle="Enter your work email and we will send you a reset link."
      testid="forgot-password-page"
      footer={<Link to="/signin" className="font-medium text-foreground underline underline-offset-4" data-testid="back-to-signin-link">Back to sign in</Link>}
    >
      {done ? (
        <FormAlert kind="success" testid="forgot-password-success">{done}</FormAlert>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <FormAlert testid="forgot-password-error">{error}</FormAlert>
          <div className="space-y-2">
            <Label htmlFor="email">Work email</Label>
            <Input id="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-password-email-input" />
          </div>
          <Button type="submit" className="w-full" disabled={busy || !email} data-testid="forgot-password-submit-button">
            {busy ? "Sending" : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
